import styled, {css} from 'styled-components';
import {STATUSES} from '@chekin/core';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Modal} from '@guestapp/old-ui-kit';

export const StyledModal = styled(Modal).attrs({
  className: 'kiosko:!max-w-[100vw] kiosko:!w-[100vw] kiosko:!h-[100vh] !left-0',
})<{status?: STATUSES}>`
  &-content {
    justify-content: center;
    align-items: center;
    overflow-x: hidden;
    height: 100vh;
    ${props =>
      props.status === STATUSES.success &&
      css`
        & .modal__title {
          margin-top: 10px;
        }
      `};
  }

  @media (max-width: ${DEVICE.mobileXL}) {
    &-content,
    &-overlay {
      animation: none;
    }
  }

  @media (min-width: ${DEVICE.mobileXL}) {
    &-content {
      animation: none;
      padding: 50px;

      min-width: 362px;
      min-height: 322px;
      height: auto;
      & .modal__title {
        font-size: 18px;
        font-weight: 600;
        margin: 10px 0 0;
      }

      & .modal__description {
        font-size: 16px;
        font-weight: 400;
        margin-top: 24px;
      }
    }
  }
`;
